import { useState } from "react";
import { toast } from "sonner";
import { MailCheck, LogOut } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { usePublicPageForceLightClass } from "@/hooks/use-public-page-theme";

// Mostrata al posto della dashboard finché `user.email_verified` è false —
// vedi ProtectedRoute.js. Nessuna route propria: è un "gate", non una pagina.
export default function VerifyEmailGate() {
  const { user, logout } = useAuth();
  const [loading, setLoading] = useState(false);
  // Un utente appena registrato arriva qui prima ancora di poter aprire
  // l'Aspetto in dashboard: stesso tema chiaro di default di Landing/Accedi
  // finché non ha scelto esplicitamente Scuro/Sistema, per coerenza con le
  // pagine appena viste nel flusso di registrazione.
  const forceLightClass = usePublicPageForceLightClass();

  const resend = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/resend-verification");
      if (data?.already_verified) {
        toast.info("Email già verificata: ricarica la pagina.");
      } else {
        toast.success("Email di verifica inviata di nuovo.");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Errore durante l'invio");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className={`min-h-dvh startup-bg flex items-center justify-center px-5 py-10 ${forceLightClass}`} data-testid="verify-email-gate">
      <Card className="w-full max-w-md rounded-[2rem] bg-white/82 backdrop-blur-2xl border border-white/80 shadow-2xl">
        <CardHeader>
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl startup-button text-white mb-4">
            <MailCheck className="h-6 w-6" />
          </div>
          <CardTitle className="font-display text-3xl tracking-[-0.05em]">Conferma la tua email</CardTitle>
          <p className="mt-3 text-sm leading-6 text-muted-foreground">
            Abbiamo inviato un link di conferma a <strong>{user?.email}</strong>. Aprilo per attivare l'account e accedere alla dashboard.
          </p>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button
            data-testid="resend-verification-button"
            onClick={resend}
            disabled={loading}
            className="w-full rounded-2xl startup-button text-white h-12 font-extrabold border-0"
          >
            {loading ? "Invio…" : "Reinvia email di verifica"}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={logout}
            className="w-full rounded-2xl h-12 font-extrabold bg-white/60"
          >
            <LogOut className="mr-2 h-4 w-4" /> Esci
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
